import {Component, inject, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizationDirective } from '../shared/localization/localization.directive';
import { EMPTY, Observable } from 'rxjs';
import { PriceService } from '../services/price.service';

@Component({
  standalone: true,
  selector: 'price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.css'],
  imports: [CommonModule, LocalizationDirective ]
})
export class PriceComponent implements OnInit {
  priceService = inject(PriceService);
  
  @Input('product') product: string = "";


  ngOnInit(): void {
    this.setup();
  }

  price$: Observable<number> = EMPTY
  setup() {
    this.price$ = this.priceService.price$(this.product);
  }
}
